import { TOKEN } from '@/constants';
import { fetchReportedDistributorRecord, fetchUserClickBuriedPoint } from '@/services';
import wechatH5, { initH5WechatSDKConfig } from '@/services/login/wechatH5';
import wechatMp from '@/services/login/wechatMp';
import { useAppStore, useAuthStore, useUserStore, useMembershipLevelStore } from '@/store';
import { ShareSettingPageKey } from '@/types';
import { nextTick } from 'vue';
import { businessUtils } from '.';
import { commonUtils } from '../common';
import { storage } from '../storage';

const uniLogin = async () => {
  // #ifdef H5
  if (commonUtils.mp.isH5()) {
    await wechatH5();
  }
  // #endif
  // #ifdef MP-WEIXIN
  await wechatMp();
  // #endif
};

const beforeHandler = async () => {
  await nextTick();
  const userStore = useUserStore();
  const membershipLevelStore = useMembershipLevelStore();
  // 获取最大优惠的券数据
  await userStore.getMaxDiscountMembershipPlan(true);
  // 获取会员等级配置
  await membershipLevelStore.getLevelConfigList();
};

const afterHandler = async () => {
  await nextTick();

  const appStore = useAppStore();
  const userStore = useUserStore();
  const membershipLevelStore = useMembershipLevelStore();

  // 登录之后，执行相关请求，获取、更新
  // 获取用户信息
  await userStore.getUserInfo(true);
  // 获取用户会员信息
  await userStore.getUserMemberInfo(true);
  // 获取用户虚拟币信息
  await userStore.getVirtualCurrencyBalance(true);
  // 获取用户会员等级
  await membershipLevelStore.getOwnCustomLevel(true);
  // 获取分销员数据
  await appStore.getGetDistributor(true);
  // 分销上报
  businessUtils.outsideComein.distribution();
  // 获取精选商品配置
  await appStore.getSettings();
  // 获取店铺配置信息
  await appStore.getShopConfigs();
  // 获取省市区数据
  // await appStore.getRegionsJson(true);
  // 获取购物车角标数量
  await appStore.getShoppingTrolleyCount();
  // 获取模版id集合
  await appStore.getSubscribeMessageTemplateId();
  // 启动上报
  await fetchUserClickBuriedPoint();
  // 获取分享页面设置
  await appStore.getShareSettingPageKey();
};

export default {
  watch: async () => {
    useAuthStore().$subscribe(async (mutation, state) => {
      if (state.isLogin) {
        await afterHandler();
      }
    });
    // 执行登录之前的请求、操作
    await beforeHandler();
  },
  before: beforeHandler,
  after: afterHandler,
  check: async () => {
    try {
      const token = storage.get(TOKEN);
      console.log('[token]', token);

      // 判断是否存在或过期
      if (!token) {
        await uniLogin();
      } else {
        // 设置登录标识
        useAuthStore().isLogin = true;

        // 上报enterOptions
        const enterOptions = uni.getEnterOptionsSync();
        fetchReportedDistributorRecord(
          enterOptions.query?.scene ?? '',
          enterOptions.scene + '',
          enterOptions.query?.distributorId ?? ''
        );
      }

      // #ifdef H5
      initH5WechatSDKConfig();
      // #endif
    } catch (error) {
      /** */
    }
  },
  exection: uniLogin,
};
